/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { useNavigate, Link } from "react-router-dom";
import { Dialog, Button, Image, Anchor } from "hesus-ui-kit";
import PulseLoader from "react-spinners/PulseLoader";
import ClipLoader from "react-spinners/ClipLoader";
import axios from "axios";
import * as moment from "moment";
import { getDateFormat } from "@utils/datePickerUtils";
import closeIcon from "@icons/ic-close-white.svg";

import {
  Title,
  FormBody,
  OptionsWrapper,
  FlexRow,
  SectionContainer,
  OuterWrapper,
  RowTitleText,
  WrapperStatus,
  ContactDetail,
  ButtonData,
  CompanyDetail,
  ButtonInfo,
  CommunicationDetail,
  ContactInformation,
  CommunicationOuterWrapper,
  HeaderWrapper,
  ButtonWrapper,
  FlexEndButtonWrapper,
  FlexStartButtonWrapper,
  GridRow,
  SubTitle,
} from "./ClientUserView.styled";
import { avatarIcons, avatarIconsMr, avatarIconsMs } from "@utils/avatarInfo";

import emailIcon from "@icons/ic-email.svg";
import phoneIcon from "@icons/ic-phone.svg";
import mobilePhoneIcon from "@icons/ic-mobile-phone.svg";

const ClientUserView = (props) => {
  const {
    t,
    id,
    onClose,
    updateRefeshStatus,
    showConntactPopUp,
    handleResetPassword,
    isPasswordUpdating,
    handleStatusToggle,
    isUpdating,
  } = props;

  const [isLoading, setIsLoading] = useState(false);
  const courtseyText = { "": "", MISTER: "Mr", MISS: "Mrs" };
  const [avatarImage, setAvatarImage] = useState(avatarIcons[1]);
  const [contactInfo, setContactInfo] = useState([]);
  const avatarNumber = Math.floor(Math.random() * 10);
 

  useEffect(() => {
    if (contactInfo.lenth > 0){
      if (contactInfo.courtesy === "MISTER") {
        setAvatarImage(avatarIconsMr[avatarNumber] ?? avatarIcons[1]);
      } else if (contactInfo.courtesy === "MISS") {
        setAvatarImage(avatarIconsMs[avatarNumber] ?? avatarIcons[4]);
      } else {
        setAvatarImage(avatarIcons[avatarNumber] ?? avatarIcons[1]);
      }
    }
  }, [contactInfo]);

  useEffect(() => {
    fetchUserInfo();
  }, []);

  const history = useNavigate();

  const fetchUserInfo = () => {
    setIsLoading(true);
    axios
      .get(`/general/users/${id}`)
      .then((response) => {
        setContactInfo(response.data[0]);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  return (
    <Dialog>
      <div>
        <HeaderWrapper>
          <Title>{t("USER") + " #" + id}</Title>
          <Button
            onClick={onClose}
            styles={{
              backgroundColor: "transparent",
              border: "none",
              height: "auto",
              padding: 0,
              "&:hover": {
                backgroundColor: "transparent",
              },
            }}
          >
            <Image
              src={closeIcon}
              alt="close meeting report popup"
              styles={{ width: "auto" }}
            />
          </Button>
        </HeaderWrapper>
        {isLoading && (
          <div className="suggestions-list-loading">
            <PulseLoader color="#1bace4" size={15} />
          </div>
        )}
        <FormBody>
          <OptionsWrapper>
            {contactInfo?.user?.id && (
              <FlexRow>
                <SectionContainer>
                  <OuterWrapper>
                    {avatarImage && (
                      <Image
                        src={avatarImage}
                        alt="Avatar"
                        styles={{ height: "100px", width: "100px" }}
                      />
                    )}
                    <ContactDetail>
                      <RowTitleText>
                        {contactInfo.contact.courtesy !== null &&
                          courtseyText[contactInfo.contact.courtesy] + " "}
                        {contactInfo.contact.firstName +
                          " " +
                          contactInfo.contact.lastName}
                      </RowTitleText>
                      <CompanyDetail>
                        {contactInfo.contact.job !== null &&
                          contactInfo.contact.job + " "}
                        {contactInfo.contact.company !== null &&
                          contactInfo.contact.job !== null &&
                          t("GENERAL_AT") + " "}

                        {contactInfo.contact.company !== null && (
                          // eslint-disable-next-line jsx-a11y/anchor-is-valid
                          <Link
                            to={`/company/view/${contactInfo.contact.company.id}/general-info`}
                          >
                            {contactInfo.contact.company.name}
                          </Link>
                        )}
                      </CompanyDetail>
                    </ContactDetail>
                    <WrapperStatus>
                      {contactInfo.user.status === 1 && (
                        <ButtonInfo color="#368939" border="1px solid #368939">
                          {t("ACTIVE")}
                        </ButtonInfo>
                      )}
                      {contactInfo.user.status === 2 && (
                        <ButtonInfo color="#e83f1e" border="1px solid #e83f1e">
                          {t("INACTIVE")}
                        </ButtonInfo>
                      )}
                      {contactInfo.user.status === null && (
                        <ButtonInfo color="#ff5101" border="1px solid #ff5101">
                          {t("PENDING")}
                        </ButtonInfo>
                      )}
                    </WrapperStatus>
                  </OuterWrapper>
                  <CommunicationOuterWrapper>
                    <CommunicationDetail>
                      {contactInfo?.contact.email !== null &&
                        contactInfo?.contact?.email !== "" && (
                          <ContactInformation textDecoration="underline">
                            <Image
                              src={emailIcon}
                              alt={t("EMAIL")}
                              title={t("EMAIL")}
                              styles={{
                                width: "18px",
                                margin: "0 8px 0 8px",
                              }}
                            />
                            <Anchor
                              url={`mailto:${contactInfo.contact.email}`}
                              target="_blank"
                            >
                              {contactInfo.contact.email}
                            </Anchor>
                            <br></br>
                          </ContactInformation>
                        )}
                      <ContactInformation>
                        {contactInfo.contact.mobilePhone !== null &&
                          contactInfo?.contact?.mobilePhone !== "" && (
                            <>
                              <Image
                                src={mobilePhoneIcon}
                                alt={t("MOBILE")}
                                title={t("MOBILE")}
                                styles={{
                                  width: "18px",
                                  margin: "0 8px 0 8px",
                                }}
                              />
                              {contactInfo.contact.mobilePhone}
                            </>
                          )}
                        {contactInfo.contact.phone !== null &&
                          contactInfo?.contact?.phone !== "" && (
                            <>
                              <Image
                                src={phoneIcon}
                                alt={t("PHONE")}
                                title={t("PHONE")}
                                styles={{
                                  width: "18px",
                                  margin: "0 8px 0 8px",
                                }}
                              />
                              {contactInfo.contact.phone}
                            </>
                          )}
                      </ContactInformation>
                    </CommunicationDetail>
                  </CommunicationOuterWrapper>
                  <GridRow>
                    <SubTitle color="#0A4986" fontSize="15px" fontWeight="700">
                      {" "}
                      {t("CLIENT_USER_ACCOUNT_INFORMATION")}
                    </SubTitle>
                  </GridRow>
                  <hr></hr>
                  <GridRow column="1fr 1fr 1fr">
                    <SubTitle color="#00AEEA" fontWeight="700">
                      {t("CLIENT_USER_LOGIN_EMAIL")}
                    </SubTitle>
                    <SubTitle color="#00AEEA" fontWeight="700">
                      {t("ADMIN_LAST_LOGIN")}
                    </SubTitle>
                    <SubTitle color="#00AEEA" fontWeight="700">
                      {t("CREATED_AT")}
                    </SubTitle>
                  </GridRow>
                  <GridRow column="1fr 1fr 1fr">
                    <SubTitle color="#474747">
                      {contactInfo.user.email}
                    </SubTitle>
                    <SubTitle color="#474747">
                      {contactInfo.user.lastLogin
                        ? getDateFormat(
                            contactInfo.user.lastLogin,
                            "YYYY-MM-DD"
                          ) +
                          " " +
                          t("AT") +
                          " " +
                          moment(contactInfo.user.lastLogin).format("HH:mm")
                        : "--"}
                    </SubTitle>
                    <SubTitle color="#474747">
                      {contactInfo.user.createdAt
                        ? getDateFormat(contactInfo.user.createdAt,
                            "YYYY-MM-DD"
                          )
                        : ""}
                    </SubTitle>
                  </GridRow>
                </SectionContainer>
              </FlexRow>
            )}
          </OptionsWrapper>
        </FormBody>
        <ButtonWrapper>
          <FlexStartButtonWrapper>
            <Button
              styles={{
                color: "#fff",
                background: "#E83F1E",
                border: "1px solid #E83F1E",
                marginRight: "0.32rem",
                "&:hover": {
                  backgroundColor: "#E83F1E",
                },
              }}
              onClick={() =>
                handleStatusToggle(
                  contactInfo?.user?.id,
                  contactInfo?.user?.status
                )
              }
            >
              <>
                {" "}
                {isUpdating && <ClipLoader size={15} color="#fff" />}
                {[1, 3].includes(parseInt(contactInfo?.user?.status, 10)) &&
                  !isUpdating &&
                  t("GENERIC_ACTION_TOOLTIP_DISABLE")}
                {[2].includes(parseInt(contactInfo?.user?.status, 10)) &&
                  !isUpdating &&
                  t("GENERIC_ACTION_TOOLTIP_ACTIVATE")}
              </>
            </Button>
          </FlexStartButtonWrapper>
          <FlexEndButtonWrapper>
            {[1, 3].includes(parseInt(contactInfo?.user?.status, 10)) && (
              <Button
                styles={{
                  color: "#0A4986",
                  background: "#fff",
                  border: "1px solid #0A4986",
                  marginRight: "0.32rem",
                  "&:hover": {
                    backgroundColor: "#fff",
                  },
                }}
                onClick={() => handleResetPassword(id)}
              >
                {" "}
                <>
                  {isPasswordUpdating && (
                    <ClipLoader size={15} color="#0A4986" />
                  )}
                  {!isPasswordUpdating && t("ACTION_TOOLTIP_RESET_PASSWORD")}
                </>
              </Button>
            )}
            <Button
              styles={{
                color: "white",
                background: "#1BACE4",
                border: "1px solid #1BACE4",
                marginRight: "0.32rem",
                "&:hover": {
                  backgroundColor: "#1589b6",
                },
              }}
              onClick={() => showConntactPopUp(id)}
            >
              <>{t("CLIENT_USER_ACTION_EDIT_CONTACT")}</>
            </Button>
          </FlexEndButtonWrapper>
        </ButtonWrapper>
      </div>
    </Dialog>
  );
};

ClientUserView.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(ClientUserView);
